"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var DataType_1 = require("../common/base/DataType");
var ComputeVariablesFunction = /** @class */ (function () {
    function ComputeVariablesFunction() {
        this.statusEntries = ["OK", "Error", "Inhibited"];
        this.status = new DataItem_1.DataItem(Field_1.FIELD.STATUS, DataType_1.DataType.string);
        this.status.enum = this.statusEntries;
    }
    ComputeVariablesFunction.fromJson = function (functionName, json) {
        var variablesFunction = new ComputeVariablesFunction();
        variablesFunction.name = functionName;
        if (json[Field_1.FIELD.OUTPUTS]) {
            variablesFunction.outputs = json[Field_1.FIELD.OUTPUTS]; // FunctionOutputs.fromJson(json[FIELD.OUTPUTS]);
        }
        return variablesFunction;
    };
    ComputeVariablesFunction.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.STATUS] = this.status.toJson(false);
        json = Object.assign(json, this.outputsToJson());
        return json;
    };
    ComputeVariablesFunction.prototype.outputsToJson = function () {
        var json = Object.create(null);
        if (this.outputs !== undefined) {
            json[Field_1.FIELD.OUTPUTS] = this.outputs;
        }
        return json;
    };
    return ComputeVariablesFunction;
}());
exports.ComputeVariablesFunction = ComputeVariablesFunction;
//# sourceMappingURL=ComputeVariablesFunction.js.map